export default class RrApiAdapter {
	constructor(placements, rrConfig) {
		this.rrConfig = rrConfig ?? window.RR_CONFIG;
		this.placements = placements.join('|');
		this.catCode = this.rrConfig.product?.category?.code ?? '';
		this.cookie = window.od.Cookie;

		this.params = {
			apiKey: this.rrConfig.apiKey,
			apiClientKey: this.rrConfig.apiClientKey,
			sessionId: this.rrConfig.sessionId,
			userId: this.rrConfig.userId,
			placements: this.placements,
			includeStrategyData: true,
			returnMinimalRecItemData: true,
			productId: this.rrConfig.product?.sku,
			chi: this.catCode,
			rid: this.rrConfig.regionId,
			rcs: this.cookie.get('rr_rcs') ?? '',
		};
	}

	buildQueryString(params) {
		return Object.keys(params)
			.map(function (key) {
				return `${key}=${params[key]}`;
			})
			.join('&');
	}

	buildLink() {
		this.requestLink = `${this.rrConfig.apiUrl}?`;
		this.requestLink += this.buildQueryString(this.params);
		return this.requestLink;
	}

	async fetchData() {
		try {
			const link = this.buildLink();
			const response = await fetch(link);
			let json = {};

			if (response.ok) {
				json = await response.json();
			}
			return json;
		} catch (error) {
			if (console) console.error(error); // eslint-disable-line no-console
		}
	}

	formatData(placements) {
		const formattedPlacements = [];
		placements.forEach((item, i) => {
			formattedPlacements[i] = {};
			formattedPlacements[i].title = item.strategyMessage;
			formattedPlacements[i].zoneId = item.placement;
			formattedPlacements[i].products = {};
			formattedPlacements[i].clickTrackingURL = {};
			if (item.recommendedProducts) {
				item.recommendedProducts.forEach(product => {
					formattedPlacements[i].products[product.id] = product.clickURL;
					formattedPlacements[i].clickTrackingURL[product.id] =
						product.clickTrackingURL;
				});
			}
		});

		return formattedPlacements;
	}

	getData() {
		return new Promise((resolve, reject) => {
			if (!this.rrConfig || !this.rrConfig.product) {
				reject();
			}

			this.fetchData().then(response => {
				let data = {};
				if (response.placements && Array.isArray(response.placements)) {
					data = this.formatData(response.placements);
				}
				resolve(data);
			});
		}).catch(err => Promise.reject(new Error(err)));
	}
}
